import qs from "qs";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import PublicLayout from "views/layouts/PublicLayout";
import { default as ErrSection } from "views/sections/Err";

const Err = (props) => {
	const { search } = useLocation();
	const { t } = useTranslation();
	const {
		code: paramsCode,
		codeMessage: paramsCodeMessage,
		message: paramsMessage,
	} = qs.parse(search, { ignoreQueryPrefix: true });

	const code = props?.code || paramsCode || 404;
	const codeMessage = props?.codeMessage || paramsCodeMessage || t("system_messages.not_found");
	const message = props?.message || paramsMessage || t("system_messages.not_found_message");

	return (
		<PublicLayout pageTitle={`${code} ${codeMessage}`} type="auth" allowHeaderContent isHeaderSticky>
			<ErrSection code={code} codeMessage={codeMessage} message={message} onReset={props?.onReset} />
		</PublicLayout>
	);
};

export default Err;
